import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";

const dev = {
    apiKey: "AIzaSyBLR4JmEqxMFQXXotHEA9pmIxYPRyxaBmA",
    authDomain: "gixo-mygru-mitsui.firebaseapp.com",
    projectId: "gixo-mygru-mitsui",
    storageBucket: "gixo-mygru-mitsui.appspot.com",
    messagingSenderId: "19842789726",
    appId: "1:19842789726:web:760cd61f6e5484e4e11fcf",
    measurementId: "G-W506TNZ73T"
};

const prod = {
    apiKey: "AIzaSyBLR4JmEqxMFQXXotHEA9pmIxYPRyxaBmA",
    authDomain: "gixo-mygru-mitsui.firebaseapp.com",
    projectId: "gixo-mygru-mitsui",
    storageBucket: "gixo-mygru-mitsui.appspot.com",
    messagingSenderId: "19842789726",
    appId: "1:19842789726:web:13a287de6cfd65d4e11fcf",
    measurementId: "G-751BX9GNVY"
};

firebase.initializeApp(process.env.NODE_ENV === "production" ? prod : dev);

export default firebase.app();
export const firestore = firebase.firestore();
export const FieldValue = firebase.firestore.FieldValue;
export const Timestamp = firebase.firestore.Timestamp;
